import { Box, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { RanaAlert } from "@nens/ranalib";

import { useTenantActionAllowed } from "@/hooks/use-action-allowed-in-tenant";
import { modelSchemaIsFromCatalogue } from "@/utils/model-schema-is-from-catalogue";

import { useSchematisationDetailsContext } from "../schematisation-details-context";

export function SchematisationSourceAlert() {
  const { mode, schematisation } = useSchematisationDetailsContext();

  const { canManageDataset } = useTenantActionAllowed();

  if (mode === "catalogue" || !canManageDataset) return null;

  if (modelSchemaIsFromCatalogue(schematisation)) {
    return (
      <RanaAlert status="info">
        <Box>
          <Text as="strong">
            <FormattedMessage
              id="file.catalogue_schematisation"
              defaultMessage="This model schematisation comes from the Catalogue"
            />
          </Text>
          <Text>
            <FormattedMessage
              id="file.schematisation_storage_warning"
              defaultMessage="We're currently updating the way model schematisations are stored in Rana."
            />
          </Text>
          <Text>
            <FormattedMessage
              id="file.schematisation_storage_warning_future"
              defaultMessage="Soon, model schematisations will be copied into projects when needed, allowing you to edit the model schematisation without affecting the original version in the catalogue."
            />
          </Text>
        </Box>
      </RanaAlert>
    );
  }

  return (
    <RanaAlert status="info">
      <Box>
        <Text as="strong">
          <FormattedMessage
            id="file.project_schematisation"
            defaultMessage="This model schematisation is available only within this project"
          />
        </Text>
        <Text>
          <FormattedMessage
            id="file.schematisation_private_warning"
            defaultMessage=" If you'd like to make it available to other projects, you can submit it to the Catalogue and share it across your organisation."
          />
        </Text>
      </Box>
    </RanaAlert>
  );
}
